/**
 * @file Valtio bus for the one active dropped-file import run. `AIProvider`
 * writes `run` when a drop launches an agent import (the freshly created draft
 * form it bound the run to, plus the uploaded attachments to replay on a target
 * change); it clears `run` on success and discards (archives the draft) on
 * cancel / error / target change. `MappingReviewApprove` reads `run` to show the
 * target-form override Select and to know which draft to archive on cancel.
 *
 * Distinct from `agentLoopState` (loop lifecycle) and `agentApprovalState`
 * (pending approval) because the run context outlives the approval and predates
 * it: the draft exists from the moment the run starts until it is applied or
 * discarded.
 */
import { proxy } from 'valtio';
import type { FileAttachment } from '../../providers/AIContext';

export interface ImportRun {
  formId: string;
  formVersionId: string;
  formType: string;
  attachments: FileAttachment[];
}

export const importRunState = proxy<{ run: ImportRun | null }>({ run: null });
